import * as angular from 'angular';
import { Growl } from 'angular/custom/services/growl.service';
import * as moment from 'pkp-moment-timezone-all-years';
import { StorageLocationResource } from 'app/_resources/storage-location.resource';
import { ErrorHandler } from 'app/_services/error-handler.factory';

class StorageLocationDetailsCtrl implements ng.IController {
    public form: any;
    public storageLocationId: number;
    public storageLocation: StorageLocationDto;
    public loggedInUser: LoginResult;
    public uiLoading: boolean = true;
    public uiLoadingError: boolean = false;
    public isCreateMode: boolean =
        this.$location.path().indexOf('/storage/locations/create') > -1;
    public isEditMode: boolean =
        this.$location.path().indexOf('/storage/locations/edit') > -1;
    public isViewMode: boolean =
        this.$location.path().indexOf('/storage/locations/details') > -1;

    constructor(
        private $window,
        private storageLocationResource: StorageLocationResource,
        private authService,
        private growl: Growl,
        private $location: ng.ILocationService,
        private errorHandler: ErrorHandler
    ) {}

    $onInit() {
        this.authService.userLoginPromise.promise.then(
            (loginResult: LoginResult) => {
                if (!!loginResult) {
                    this.loggedInUser = loginResult;
                }
            }
        );
        if (this.isEditMode || this.isViewMode) {
            this.initStorageLocation();
        } else {
            this.uiLoading = false;
        }
    }

    private initStorageLocation(): void {
        this.storageLocationResource
            .get(
                { id: this.storageLocationId },
                (res: StorageLocationDto) => {
                    this.storageLocation = res;
                },
                (err: ng.IHttpPromiseCallbackArg<RestError>) => {
                    this.errorHandler(err);
                }
            )
            .$promise.finally(() => (this.uiLoading = false));
    }

    private submitStorageLocation(): void {
        this.uiLoading = true;
        this.storageLocationResource
            .save(
                this.storageLocation,
                (res) => {
                    this.growl.show(
                        'Storage location <strong>' +
                            this.storageLocation.name +
                            '</strong> sucessfully saved.',
                        'success',
                        { allowHtml: true }
                    );
                    this.$location.path('/storage/locations');
                },
                (err: ng.IHttpPromiseCallbackArg<RestError>) => {
                    const errorMessage =
                        err && err.data && err.data.message
                            ? err.data.message
                            : 'An unknown error occurred. Please, check back later.';
                    if (errorMessage == 'Validity mismatch') {
                        let message =
                            '<p><strong>' + errorMessage + '</strong></p>';
                        message +=
                            '<p>Capacity at this storage location is currently marketed.<br/>Please consider the runtime of the following offers:</p>';
                        let errorOffers = JSON.parse(
                            err.data.description || '[]'
                        );

                        angular.forEach(errorOffers, (errorOffer: number) => {
                            let errorDetails = 'Offer ID: ';
                            errorDetails +=
                                "<a target='_blank' href='#/storage/offers/details/" +
                                errorOffer +
                                "'>";
                            errorDetails += errorOffer;
                            errorDetails += '</a><br />';
                            message += errorDetails;
                        });
                        this.growl.show(message, 'danger');
                    } else {
                        this.growl.show(errorMessage, 'danger');
                    }
                }
            )
            .$promise.finally(() => (this.uiLoading = false));
    }

    public submit(form: ng.IFormController): boolean {
        if (
            moment(this.storageLocation.validity.start).isSameOrBefore(
                moment(new Date())
            )
        ) {
            const errorText = 'The start date is not in the future.';
            this.growl.show(
                `<strong>Validation error</strong><br/>${errorText}`,
                'danger',
                { allowHtml: true }
            );
            this.form.validity.$invalid = true;
            return false;
        }

        if (!form.$valid) {
            this.growl.show(
                '<strong>Validation error</strong><br/>Please check all mandatory fields.',
                'danger',
                { allowHtml: true }
            );
            return false;
        }
        this.submitStorageLocation();

        return true;
    }
}

angular.module('app').component('pkpStorageLocationDetailsPage', {
    controller: StorageLocationDetailsCtrl,
    template: require('app/storage-location/storage-location-details.component.html'),
    bindings: {
        storageLocationId: '<?'
    }
});
